import { render, staticRenderFns } from "./leagueModal.vue?vue&type=template&id=2df32e1e&lang=pug&"
import script from "./leagueModal.vue?vue&type=script&lang=js&"
export * from "./leagueModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports